import ChemicalCard from './ChemicalCard';
import { AccordionWrapper } from 'react-lib/dist/components-es';
import ButtonWrapper from '@components/common/ButtonWrapper';
import { ActivityChemicalsDTO } from '@behavior/activity/dto/ActivityChemicalsDTO';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

type Props = {
  chemicalProductsList?: ActivityChemicalsDTO[];
  setChemicalProductsList?: (chemicalProductsList: ActivityChemicalsDTO[]) => void;
  chemicalProductIdList?: number[];
  setChemicalProductIdList?: (chemicalProductIdList: number[]) => void;
  chemicalCards?: number[];
  setChemicalCards?: (chemicalCards: number[]) => void;
  count?: number;
  addChemicalCard?: () => void;
};

const ActivityChemical = ({
  chemicalProductsList,
  setChemicalProductsList,
  chemicalProductIdList,
  setChemicalProductIdList,
  chemicalCards,
  setChemicalCards,
  addChemicalCard,
}: Props) => {
  const { setValue } = useFormContext();

  const removeChemicalCard = (cardKey: number, index: number) => {
    const updatedCards = chemicalCards?.filter(key => key !== cardKey);
    const updatedChemicals = chemicalProductIdList?.filter(i => i !== index);
    if (setChemicalProductIdList && updatedChemicals) {
      setChemicalProductIdList(updatedChemicals);
    }
    if (setChemicalCards && updatedCards) {
      setChemicalCards(updatedCards);
    }
    const updatedChemicalProductsList = chemicalProductsList?.filter(
      product => product.chemicalProduct.id !== index
    );
    if (setChemicalProductsList && updatedChemicalProductsList) {
      setChemicalProductsList(updatedChemicalProductsList);
    }
  };

  useEffect(() => {
    setValue('chemicalProduct', chemicalProductsList);
  }, [chemicalProductsList]);

  const getContainerBody = () => {
    return (
      <div>
        {chemicalCards?.map((cardKey, index) => (
          <div key={cardKey}>
            <ChemicalCard
              onRemove={() => {
                if (chemicalProductIdList) {
                  removeChemicalCard(cardKey, chemicalProductIdList[index]);
                }
              }}
              prevChemicalProductId={chemicalProductIdList && chemicalProductIdList[index]}
              setChemicalProductIdList={setChemicalProductIdList}
              chemicalProductsList={chemicalProductsList}
              setChemicalProductsList={setChemicalProductsList}
              cardKey={cardKey}
            />
          </div>
        ))}
        <div className="activityAddButton">
          <ButtonWrapper
            label="activity.details.page.components.activity.chemical.add"
            primary
            icon="add"
            onClick={addChemicalCard}
          />
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (chemicalCards?.length === 0 && addChemicalCard) {
      addChemicalCard();
    }
  }, [chemicalCards?.length]);

  return (
    <AccordionWrapper
      closable={false}
      accordionTitle="activity.details.page.components.activity.chemical.title"
      render={getContainerBody}
      className="activityChemicalContainer"
    />
  );
};

export default ActivityChemical;
